<template>
<div class="search_container searchArea">
    <el-form :inline="true" :model='searchInfo' ref="searchInfo" :rules="rules">
        <el-form-item label="用户名称">
            <el-input v-model="searchInfo.operatorName" @change="nameChange" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户手机号">
            <el-input v-model="searchInfo.operatorTel" @change="phoneChange" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" round @click="searchList()">查询</el-button>
            <el-button type="primary" round @click="addYH()">新增</el-button>
        </el-form-item>

    </el-form>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'

export default {
    operatorName: 'searchItem',
    props: {
        searchInfo: {
            type: Object,
            required: true
        }

    },
    data() {
        return {
            rules: {}
        }
    },
    computed: {},
    created() {},
    methods: {
        // 查询
        searchList() {
            this.$emit('searchList', this.searchInfo)
        },
        addYH(){
             this.$emit('addYH')
        },
        nameChange(e) {
            this.searchInfo.operatorName = e
            this.$emit('update:searchInfo', this.searchInfo)
        },
        phoneChange(e) {
            this.searchInfo.operatorTel = e
            this.$emit('update:searchInfo', this.searchInfo)
        }
    }
}
</script>

<style>
.search_container {
    padding: 40px 0 18px;
}
.el-date-editor .el-range-separator{
    padding:0;
}
</style>
